import React from 'react';
import { useTranslation } from 'react-i18next';

const TermosTexto = () => {
  const { t } = useTranslation();
  const items = t('terms.items', { returnObjects: true });

  return (
    <div>
      <p>{t('terms.intro')}</p>
      {Array.isArray(items) && items.map((item, index) => (
        <p key={item}>
          <strong>{index + 1} - </strong>
          {item}
        </p>
      ))}
    </div>
  );
};

export default TermosTexto;
